import React from 'react'

import { GroupHealthPlanDetails as GroupHealthPlanDetailsDto } from 'core/application/csiDashboard/csiSearch/getProgramDetails'

import Item from 'common/components/dataDisplay/ItemWithoutSpacing'

import { parseZoneMonthYearFormat } from 'common/dateFormatters'

interface GroupHealthPlanDetailsProps {
  translate: (key: string) => string
  groupHealthPlanDetails: GroupHealthPlanDetailsDto
}

const GroupHealthPlanDetails: React.FC<GroupHealthPlanDetailsProps> = ({ translate, groupHealthPlanDetails }) => {
  return (
    <div>
      <div>
        <h5>{translate('csi-dashboard.program-details.group-health-plan')}</h5>
      </div>
      <div className="flex flex__space_between">
        <Item
          translate={translate}
          title={translate('csi-dashboard.program-details.group-health-plan-start-month')}
          text={groupHealthPlanDetails.startDate ? parseZoneMonthYearFormat(groupHealthPlanDetails.startDate) : null}
        />
        <Item
          translate={translate}
          title={translate('csi-dashboard.program-details.group-health-insurance-carrier')}
          text={groupHealthPlanDetails.insuranceCarrier}
        />
        <Item
          translate={translate}
          title={translate('csi-dashboard.program-details.group-health-insurance-plan')}
          text={groupHealthPlanDetails.insurancePlan}
        />
        <Item
          translate={translate}
          title={translate('csi-dashboard.program-details.group-health-plan-waiting-period')}
          text={groupHealthPlanDetails.waitingPeriod}
        />
      </div>
    </div>
  )
}

export default GroupHealthPlanDetails
